// extracted by mini-css-extract-plugin
module.exports = {"link":"ftAYz","linkBlock":"pixQh","medium":"qofcV","hideOnDesktop":"n4k1Y"};